export default __webpack_public_path__ + "static/logo-white-ddfb06217b4406d145e5d22f608ea195.svg";